// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-unread {\n  background-color: #d5e1e9;\n}\n\n.bg-read {\n  background-color: white;\n}\n\n.btn-orange {\n  background: #ffffff;\n  color: #eb6418;\n  padding: 2px 5px;\n  border-radius: 10px;\n  height: 26px;\n  border: solid 1px #eb6418;\n}\n.btn-orange:hover {\n  color: white;\n  background: #eb6418;\n  transition: all 0.2s;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
